import { Box, Sx } from "@mantine/core";
import React from "react";
import ReactJson, { ReactJsonViewProps } from "react-json-view";

interface JsonBoxProps extends Omit<ReactJsonViewProps, "src"> {
  data?: object;
  sx?: Sx;
  "data-testid"?: string;
}

export const JsonBox: React.FC<JsonBoxProps> = ({ data, sx, ...props }) => {
  if (!data) return <></>;
  const { ["data-testid"]: testId, ...reactJsonProps } = props;
  return (
    <Box
      data-testid={testId}
      sx={[
        (theme) => ({
          backgroundColor: theme.colors.sky[5],
          borderRadius: 1,
          width: "100%",
          padding: 12,
        }),
        sx,
      ]}
    >
      <ReactJson src={data} name={null} collapsed={1} displayDataTypes={false} {...reactJsonProps} />
    </Box>
  );
};
